Greenmile.Survey = Greenmile.Survey || {};

Greenmile.Survey.Form = {

    /**
     * Called when show existents questions on form
     *
     * @param sectionData
     * @param section
     * @param questions
     * @param parentQuestionId
     */
    addQuestions: function (sectionData, section, questions, parentQuestionId) {

        var question,
            questionContent,
            questionObject,
            questionData,
            input,
            links,
            subQuestions    = [],
            linkedQuestions = [];

        var sortSurveyDomain = function (a, b) {

            return a.surveyQuestionDomainOrder - b.surveyQuestionDomainOrder;

        };

        for (var j = 0; j < questions.length; j++) {


            question = questions[j];
            questionObject = Greenmile.Survey.SidebarFactory.factoryItemFromJsonType(question.type);
            questionData = {};
            input = {};
            links = null;

            if (question.surveyQuestionDomain) {
                question.surveyQuestionDomain.sort(sortSurveyDomain);
            }

            input.questionType = questionObject.questionType;
            input.questionText = question.question;
            input.answerOptions = question.surveyQuestionDomain;
            input.questionData = questionData;

            questionContent = this.addQuestionContentFromEdit(sectionData, question, input, parentQuestionId);

            questionData.id = question.id;
            questionData.key = question.key;
            questionData.questionType = questionContent.getAttribute('questionType');
            questionData.order = question.questionOrder;
            questionData.el = questionContent;
            questionData.isMandatory = question.mandatory;
            questionData.requirePhoto = question.requirePhoto;
            questionData.isLoop = question.loopQuestion;
            questionData.finishSurvey = question.finishSurvey;
            questionData.surveyQuestionDomain = question.surveyQuestionDomain;
            questionData.type = questionObject.jsonType;
            questionData.question = question.question;
            questionData.nextQuestion = question.nextQuestion;
            questionData.parentQuestionId = parentQuestionId;
            questionData.entity = question.entity;
            questionData.entityProjection = question.entityProjection || question.projection;
            questionData.entityRestriction = question.entityRestriction || question.criteria;
            questionData.defaultAnswer = question.defaultAnswer;
            questionData.entityAvoidDuplicateSelection = question.entityAvoidDuplicateSelection;
            questionData.questionObject = questionObject;
            questionData.alreadyEdited = false;
            questionData.toDelete = [];
            questionData.generateTask = question.generateTask;
            questionData.jsonParameter = question.jsonParameter ? JSON.parse(question.jsonParameter) : {};

            Greenmile.Survey.Data.addQuestionToSection(sectionData.id, questionData, parentQuestionId);
            Greenmile.Survey.Widgets.addMenu(questionData.id, section.id, parentQuestionId);
            Greenmile.Survey.Widgets.appendLinkElementToQuestion(questionContent, questionData);

            if (!Greenmile.Survey.Builder.closedDate &&
                Greenmile.Survey.Builder.releasedDate &&
                (['PICKLIST', 'PICKLIST_MULTISELECT', 'ENTITY'].indexOf(questionData.questionType) !== -1)) {

                Greenmile.Survey.Widgets.appendButtonsToAddQuestionAfterReleased(questionContent, question.id, questionData);

            }

            questionObject.addQuestionContent(questionContent, input);
            links = this.createLinkObjects(question);
            linkedQuestions = linkedQuestions.concat(links);

            if (questionData.entityRestriction) {
                const restriction = JSON.parse(questionData.entityRestriction);
                const criteria = restriction.criteriaChain[0].and[0];
                if (criteria && criteria.attr !== 'id') {
                    const sampleData = document.createElement('div');
                    sampleData.className = 'SurveySampleData';
                    sampleData.innerHTML = Monet.I18n.getResourcesByKey('Greenmile.Survey.Released.SampleData');

                    const filter = document.createElement('div');
                    filter.className = 'SurveyFilterLabel';
                    filter.innerHTML = '<span>' +
                      Monet.I18n.getResourcesByKey('Greenmile.Survey.Released.filter') + '</span>: <br/>';

                    restriction.criteriaChain[0].and.map(function(item) {
                        var str = item.attr + ': ';

                        switch(item.matchMode) {
                            case 'START':
                                str += '*' + item.eq;
                                break;
                            case 'END':
                                str += item.eq + '*';
                                break;
                            case 'ANYWHERE':
                                str += '*' + item.eq + '*';
                                break;
                            default:
                                str += item.eq;
                                break;
                        }
                        str += '<br/>';
                        filter.innerHTML = filter.innerHTML + str;
                    });

                    const divAnswerContent = questionContent.querySelector('.answerContent');
                    divAnswerContent.appendChild(sampleData);
                    divAnswerContent.appendChild(filter);
                }
            }


            subQuestions = question.subQuestions;
            if (subQuestions && subQuestions.length) {
                this.addQuestions(sectionData, section, subQuestions, question.id);
            }


        }

        for (var k = 0; k < linkedQuestions.length; k++) {

            this.doneLinkingQuestions(linkedQuestions[k]);

        }


    },

    addApplyRules: function (survey) {

      const { rules, operatorsByFieldType, ruleTypeByTrigger } = Greenmile.Survey.SurveyApplyRule;

      const buildRuleDataField = (rules, jsonRule) => {
        return rules.reduce((acc, rule) => {
          const field = rule.fields.filter(field =>
            (field.attr && field.attr === jsonRule.attr) || (jsonRule.customAttr && field.customAttr === jsonRule.customAttr)
          );
          if (field.length) {
            acc = field[0];
          }
          return acc;
        }, {});
      };

      const formatDataToApplyRule = applyRule => {
        const jsonRules = (applyRule.jsonRule) ? JSON.parse(applyRule.jsonRule) : [];
        const rulesFormatted = new Map();
        jsonRules.forEach(jsonRule => {
          const ruleData = {
            field: {},
            operator: '',
            value: null
          };

          ruleData.field = buildRuleDataField(rules, jsonRule);

          const setRuleDataValue = value => { ruleData.value = value };
          const getRuleDataValue = () => ruleData.value;

          if (ruleData.field.attr === 'Stop.orders.isNewOrder') {
            ruleData.operator = null;
          } else if (ruleData.field.customAttr) {

            let customAttrSplited =  [];
            if (ruleData.field.customAttr === "Order.delivered") {
              customAttrSplited = jsonRule.eq.replace(/\@/g, '').split('.');
            } else {
              customAttrSplited = jsonRule.attr.split('.');
            }
            setRuleDataValue(customAttrSplited[customAttrSplited.length - 1]);

          } else if (ruleData.field.type) {
            const operatorsEnabled = operatorsByFieldType[ruleData.field.type];
            ruleData.operator = operatorsEnabled.reduce((acc, item) => {
              if (jsonRule.hasOwnProperty(item)) {
                acc = item;
              }
              return acc;
            }, '');
            if (ruleData.field.type !== 'lookup') {
              setRuleDataValue(jsonRule[ruleData.operator]);

              if (typeof getRuleDataValue()  === "number") {
                  setRuleDataValue(getRuleDataValue().toString());
              }

            } else {

              const value = jsonRule[ruleData.operator];
              if (Array.isArray(value)) {
                setRuleDataValue(value);
              } else {

                setRuleDataValue({});
                const ruleDataValue = getRuleDataValue();
                if (jsonRule.attr.includes('key') && !jsonRule.key) {
                    ruleDataValue[`id`] = jsonRule.id;
                    ruleDataValue[ruleData.field.column] = value;
                } else {
                    ruleDataValue[`id`] = value;
                    ruleDataValue[ruleData.field.column] = jsonRule[ruleData.field.column] || jsonRule.description;
                }

              }
            }
          }
          if (getRuleDataValue() === false || getRuleDataValue()) {
            rulesFormatted.set(uuid(), ruleData);
          }
        });
        return {
          id: applyRule.id,
          trigger: 'BEFORE',
          when: {
            value: applyRule.surveyType,
            label: Monet.I18n.getResourcesByKey(
              Greenmile.Survey.SurveyApplyRule.triggerEvents[applyRule.surveyType]
            ),
            ruleType: ruleTypeByTrigger[applyRule.surveyType]
          },
          rules: rulesFormatted
        };
      };
      Greenmile.Survey.SurveyApplyRule.data = (survey.surveyApplyRules || []).map(formatDataToApplyRule);
      Greenmile.Survey.SurveyApplyRule.renderRulesList();
    },

    disableButtons: function () {
        if (Greenmile.Survey.Builder.closedDate) {
            $('#Survey .generalForm .formButtons input[type="button"][class!="btn-secondary"]')
                .attr('disabled', 'disabled');
        }

        if (Greenmile.Survey.Builder.releasedDate || Greenmile.Survey.Builder.closedDate) {
            const addSectionButton = document.querySelector('#Survey .surveySections .oneface-button.addItem');
            const addActionButton = document.querySelector('#Survey .actionsSection .oneface-button.addItem');

            addSectionButton.style.display = 'none';
            addActionButton.style.display = 'none';

            $('#Survey input[type!="button"]').attr('disabled', 'disabled');
            $('#Survey textarea').attr('disabled', 'disabled');
            $('#Survey .applicationRules button.addItem').attr('disabled', 'disabled');
            $('#Survey .organizationTreeViewContainer').attr('disabled', 'disabled');

            $('#Survey .subQuestionContent input.addItem').hide();
            $('#Survey .actionsSection .destroyGroup').hide();
            $('#Survey .actionsSection .buttonAdd').hide();
            $('#Survey .actionsSection select').attr('disabled', 'disabled');
        }

        this.verifyQuestionsToEnableActionButton();
    },

    addQuestionContentFromEdit: function (section, question, input, parentQuestionId) {

        var sectionContent = section.el.querySelector(this.getQuestionGroupSelector(section.id, parentQuestionId));
        var questionContent = Greenmile.Survey.Widgets.questionContentWidget(question, parentQuestionId);

        questionContent.setAttribute('questionType', input.questionType);
        sectionContent.appendChild(questionContent);

        return questionContent;

    },

    createLinkObjects: function (question) {

        var domain,
            linkObject = [];

        var getLinkObj = function (answerId, questionId, model, type) {
            return {
                answerId: answerId,
                questionId: questionId,
                linkType: type,
                link: {
                    value: model.nextQuestion.id,
                    description: model.nextQuestion.question
                }

            };
        };

        if (question.nextQuestion) {
            linkObject.push(getLinkObj(null, question.id, question, Greenmile.Survey.Link.questionLinkType));
        }

        if (question.surveyQuestionDomain) {

            for (var i = 0; i < question.surveyQuestionDomain.length; i++) {

                domain = question.surveyQuestionDomain[i];

                if (domain.nextQuestion) {
                    linkObject.push(getLinkObj(domain.id, question.id, domain, Greenmile.Survey.Link.answerLinkType));
                }

            }

        }

        return linkObject;

    },

    createNewAction: function(surveyAction = Greenmile.Survey.Data.addSurveyAction()) {
        const actionWidget = Greenmile.Survey.Widgets.actionWidget(surveyAction);
        const actionSectionContainer = document.querySelector('#Survey .actionsSection #generateTaskSectionContainer');
        actionSectionContainer.appendChild(actionWidget);
        Greenmile.Survey.Widgets.prepareActionTitles(actionWidget, surveyAction.id);
    },

    createNewSection: function () {
        const sectionContainer = document.querySelector('#Survey .sectionContainer');
        if(sectionContainer) {
            const sectionEl = Greenmile.Survey.Widgets.getSection();
            const newSectionData = {
                id: sectionEl.getAttribute('section_id'),
                el: sectionEl,
                key: uuid.v1(),
                order: Greenmile.Survey.Data.surveyData.length,
                surveyQuestions: [],
                title: '',
                enabled: false,
                isNew: true
            }
            Greenmile.Survey.Data.addSurveySection(newSectionData);
            sectionEl.addEventListener('input', event => {
                const value = event.target.value;
                Greenmile.Survey.Data.findSection(newSectionData.id).title = value;
            });
            sectionContainer.appendChild(sectionEl);
        }
    },

    showOverlayForSection: function (sectionID, parentQuestionId) {

        Greenmile.Survey.Sidebar.createQuestionToSection(sectionID, parentQuestionId);

    },

    /**
     * called when a questions is created (new).
     *
     * @param sectionID
     * @param input
     * @param parentQuestionId
     */
    doneCreatingQuestion: function (sectionID, input, parentQuestionId, questionObject) {

        var questionContent  = this.addNewQuestionContent(sectionID, input, parentQuestionId),
            questionToInsert = {},
            processedAnswers;

        questionToInsert.questionType = input.questionType;
        questionToInsert.el = questionContent;
        questionToInsert.isMandatory = false;
        questionToInsert.requirePhoto = false;
        questionToInsert.finishSurvey = false;
        questionToInsert.key = uuid.v1();
        questionToInsert.type = questionObject.jsonType;
        questionToInsert.isNew = true;
        questionToInsert.question = input.questionText;
        questionToInsert.id = questionContent.getAttribute('question_id');
        questionToInsert.order = document.querySelectorAll('.newQuestionContent').length;
        questionToInsert.entity = input.entity;
        questionToInsert.entityProjection = input.projection;
        questionToInsert.entityRestriction = input.criteria;
        questionToInsert.defaultAnswer = input.defaultAnswer;
        questionToInsert.questionObject = questionObject;

        questionToInsert.defaultAnswer = input.defaultAnswer;
        questionToInsert.entityAvoidDuplicateSelection = input.entityAvoidDuplicateSelection;

        if (input.answerOptions) {

            processedAnswers = [];

            for (var i = 0; i < input.answerOptions.length; i++) {

                var id = uuid.v4();

                processedAnswers.push({
                    description: input.answerOptions[i].description,
                    value: input.answerOptions[i].value,
                    id: id.toString(),
                    isNew: true
                });

            }

            input.answerOptions = processedAnswers;
            questionToInsert.surveyQuestionDomain = processedAnswers;

        }

        Greenmile.Survey.Data.addQuestionToSection(sectionID, questionToInsert, parentQuestionId);
        Greenmile.Survey.Widgets.addMenu(questionContent.getAttribute('question_id'), sectionID, parentQuestionId);
        Greenmile.Survey.Widgets.appendLinkElementToQuestion(questionContent, questionToInsert);

        input.questionData = questionToInsert;
        questionObject.addQuestionContent(questionContent, input);

    },

    getQuestionGroupSelector: function (sectionID, parentQuestionId) {
        var parentSelector = (parentQuestionId ? '[question_id="' + parentQuestionId + '"] .subQuestionContent' : '');
        return ('[section_id="' + sectionID + '"] .questionGroupContent ' + parentSelector);
    },

    addNewQuestionContent: function (sectionID, input, parentQuestionId) {

        var sectionContent  = document.querySelector(this.getQuestionGroupSelector(sectionID, parentQuestionId)),
            questionContent = Greenmile.Survey.Widgets.getNewQuestionContent(parentQuestionId);

        questionContent.setAttribute('questionType', input.questionType);
        sectionContent.appendChild(questionContent);

        return questionContent;

    },

    updateJumpText: function (questionData) {
        Greenmile.Survey.Form.linkedQuestions = Greenmile.Survey.Form.linkedQuestions.map(function (item) {
            if (item.link.value === questionData.id) {
                item.link.description = questionData.question;
            }
            return item;
        }.bind(this));
    },

    //if question hasn't been edited yet, prepare to delete old answers from database
    checkAlreadyEdited: function (questionData) {
        //if survey is being created for the first time then there is no database questions to delete
        if (!questionData.alreadyEdited && questionData.toDelete){
            questionData.alreadyEdited = true;

            if (questionData.surveyQuestionDomain){
                questionData.toDelete = questionData.toDelete.concat(questionData.surveyQuestionDomain)
            }
        }
    },

    /**
     * Called when an existent question is saved on edit question and its type has changed.
     *
     * @param questionID
     * @param input
     * @param parentQuestionId
     */
    doneEditingQuestionChangingType: function (questionID, input, sideItem, parentQuestionId) {

        let questionData   = Greenmile.Survey.Data.findQuestion(questionID),
            updatedQuestion;

        updatedQuestion = Greenmile.Survey.Builder.buildSingleQuestion(questionData);
        questionData.questionType = input.questionType;
        questionData.mandatory = updatedQuestion.mandatory;
        questionData.requirePhoto = updatedQuestion.requirePhoto;
        questionData.loop = updatedQuestion.loopQuestion;
        questionData.finishSurvey = updatedQuestion.finishSurvey;
        questionData.type = updatedQuestion.type;
        questionData.question = input.questionText;
        questionData.entity = input.entity;
        questionData.entityProjection = input.projection;
        questionData.entityRestriction = input.criteria;
        questionData.defaultAnswer = input.defaultAnswer;
        questionData.entityAvoidDuplicateSelection = input.entityAvoidDuplicateSelection;
        questionData.questionObject = sideItem;

        this.checkAlreadyEdited(questionData);

        if (input.answerOptions) {

            //delete all question's answers
            questionData.surveyQuestionDomain = [];

            //delete all 'jump to' links from this question's answers
            Greenmile.Survey.Form.linkedQuestions = Greenmile.Survey.Form.linkedQuestions.filter(
                link => link.questionId !== questionData.id || link.linkType !== 'answerLinkType'
            );

            //create new question answers
            for (var i = 0; i < input.answerOptions.length; i++) {

                var id = new Date().getTime() + Math.floor((Math.random() * 1000) + i);
                var q = {
                    id: id.toString(),
                    isNew: true
                };

                for (var j in input.answerOptions[i]) {
                    q[j] = input.answerOptions[i][j];

                }
                questionData.surveyQuestionDomain.push(q);
            }

        }

        input.answerOptions = questionData.surveyQuestionDomain;
        input.questionData = questionData;
        sideItem.addQuestionContent(questionData.el, input, parentQuestionId);

        this.updateJumpText(questionData);
    },

    /**
     * Called when a existent question is saved. On edit question.
     *
     * @param questionID
     * @param input
     * @param parentQuestionId
     */
    doneEditingQuestion: function (questionID, input, parentQuestionId) {

        var questionData   = Greenmile.Survey.Data.findQuestion(questionID),
            questionObject = input.questionData.questionObject,
            updatedQuestion;

        updatedQuestion = Greenmile.Survey.Builder.buildSingleQuestion(questionData);
        questionData.questionType = input.questionType;
        questionData.mandatory = updatedQuestion.mandatory;
        questionData.requirePhoto = updatedQuestion.requirePhoto;
        questionData.loop = updatedQuestion.loopQuestion;
        questionData.finishSurvey = updatedQuestion.finishSurvey;
        questionData.type = updatedQuestion.type;
        questionData.question = input.questionText;
        questionData.entity = input.entity;
        questionData.entityProjection = input.projection;
        questionData.entityRestriction = input.criteria;
        questionData.defaultAnswer = input.defaultAnswer;
        questionData.entityAvoidDuplicateSelection = input.entityAvoidDuplicateSelection;

        this.checkAlreadyEdited(questionData);

        if (input.answerOptions) {

            //delete all question's answers
            questionData.surveyQuestionDomain = [];

            //delete all 'jump to' links from this question's answers
            Greenmile.Survey.Form.linkedQuestions = Greenmile.Survey.Form.linkedQuestions.filter(
              link => link.questionId !== questionData.id || link.linkType !== 'answerLinkType'
            );

            //create new question answers
            for (var i = 0; i < input.answerOptions.length; i++) {

                var id = new Date().getTime() + Math.floor((Math.random() * 1000) + i);
                var q = {
                    id: id.toString(),
                    isNew: true
                };

                for (var j in input.answerOptions[i]) {
                    q[j] = input.answerOptions[i][j];

                }
                questionData.surveyQuestionDomain.push(q);
            }

        }

        input.answerOptions = questionData.surveyQuestionDomain;
        questionObject.addQuestionContent(questionData.el, input, parentQuestionId);

        this.updateJumpText(questionData);
    },

    reconstructSection: function (section) {

        var questionEl;

        section.surveyQuestions.sort(function (a, b) {
            return a.order - b.order;
        });

        for (var j = 0, length = section.surveyQuestions.length; j < length; j++) {

            questionEl = section.surveyQuestions[j].el;
            questionEl.parentNode.appendChild(questionEl);

        }
    },

    showLinkOverlayForQuestion: function (question) {

        Greenmile.Survey.Link.createLinkOverlayForQuestion(question);

    },

    showLinkOverlayForAnswer: function (answer, question) {

        var answerEl   = $('#' + answer.id)[0],
            questionEl = answerEl.parentNode.parentNode,
            questionID = question.id;

        while (!questionID) {

            questionEl = questionEl.parentNode;
            questionID = questionEl.getAttribute('question_id');

        }

        Greenmile.Survey.Link.createLinkOverlayForAnswer(question, answer.id, answer.isNew);

    },

    showEditOverlayForAnswer: function (answer) {

        var answerEl   = $('#' + answer.id)[0],
            questionEl = answerEl.parentNode.parentNode,
            questionID = questionEl.getAttribute('question_id'),
            questionData;

        while (!questionID) {

            questionEl = questionEl.parentNode;
            questionID = questionEl.getAttribute('question_id');

        }

        questionData = Greenmile.Survey.Data.findQuestion(questionID);
        Greenmile.Survey.Edit.editAnswer(questionData, answer);

    },

    showRemoveOverlayForAnswer: function (answer) {

        var answerEl   = $('#' + answer.id)[0],
            questionEl = answerEl.parentNode.parentNode,
            questionID = questionEl.getAttribute('question_id'),
            questionData;

        while (!questionID) {

            questionEl = questionEl.parentNode;
            questionID = questionEl.getAttribute('question_id');

        }

        questionData = Greenmile.Survey.Data.findQuestion(questionID);
        Greenmile.Survey.Edit.removeAnswer(questionData, answer);

        if (Greenmile.Survey.Builder.releasedDate && !Greenmile.Survey.Data.existNewItem()) {

            var btnAddNewItems = document.querySelector('#Survey #addNewItems');

            if (btnAddNewItems) {
                btnAddNewItems.parentNode.removeChild(btnAddNewItems);
            }

        }

    },

    renderJumpTo: function (linkData) {

        var linkTag      = document.createElement('div'),
            exclude      = document.createElement('div'),
            labelJumpTo  = document.createElement('b'),
            sourceObject = Greenmile.Survey.Data.findQuestion(linkData.questionId),
            linkIndex,
            strContent;


        var excludeJumpTo = (function (scope, link) {

            return function () {

                var parentNode = linkTag.parentNode;
                var indexAvailable = [];
                var linksEnabled = [];

                if (parentNode) {
                    parentNode.removeChild(linkTag);
                }

                for (var i = 0; i < Greenmile.Survey.Form.linkedQuestions.length; i++) {

                    var iLink = Greenmile.Survey.Form.linkedQuestions[i];

                    if (iLink.linkId.toString() === link.linkId.toString()) {

                        linkIndex = i;

                    } else {

                        indexAvailable.push(i);

                    }

                }

                var indexAvailableLength = indexAvailable.length;

                if (linkData.linkType === Greenmile.Survey.Link.answerLinkType) {

                    sourceObject = Greenmile.Survey.Data.findQuestionDomain(sourceObject, linkData.answerId);

                }

                for (var j = 0; j < indexAvailableLength; j++) {

                    var index = indexAvailable[j];
                    var linkedQuestions = Greenmile.Survey.Form.linkedQuestions[index];

                    linksEnabled.push(linkedQuestions);

                }

                delete sourceObject.nextQuestion;
                Greenmile.Survey.Form.linkedQuestions = linksEnabled;
                scope.showAnswerLinks(linkData);

            };


        }(this, linkData));

        labelJumpTo.innerHTML = Monet.I18n.getResourcesByKey('Greenmile.Survey.label.jumpTo');

        var value = linkData.link.description;
        var maxLength = 50;

        if (value.length > maxLength) {

            value = (Greenmile.Survey.Sidebar.answerCropExceedLength([{value: linkData.link.description}], maxLength))[0].value + '...';

        }

        var name = document.createElement("span");
        name.innerHTML = value;

        strContent = labelJumpTo.outerHTML + ' ' + name.outerHTML;

        linkTag.title = linkData.link.description;
        linkTag.className = 'linkTag';
        linkTag.setAttribute('link_question', linkData.link.value);
        linkTag.setAttribute('link_id', linkData.linkId);

        exclude.className = 'excludeJumpTo';
        exclude.innerHTML = 'x';

        exclude.removeEventListener('click', excludeJumpTo);
        exclude.addEventListener('click', excludeJumpTo);

        linkTag.appendChild(exclude);
        linkTag.insertAdjacentHTML('beforeend', strContent);

        if (Greenmile.Survey.Builder.releasedDate && !linkData.isNew) {

            exclude.style.display = 'none';

        }

        return linkTag;

    },

    doneLinkingQuestions: function (linkedQuestion, isNew) {

        var parentElement,
            content;

        linkedQuestion.linkId = new Date().getTime() + Math.floor((Math.random() * 1000));
        linkedQuestion.isNew = isNew;

        content = Greenmile.Survey.Form.renderJumpTo(linkedQuestion);
        parentElement = this.getParentElement(linkedQuestion);

        this.clearLinkObjectsForQuestion(linkedQuestion);
        this.removePreviousLinkTag(parentElement);
        parentElement.appendChild(content);
        this.hideAnswerLinks(linkedQuestion);

        Greenmile.Survey.Form.linkedQuestions.push(linkedQuestion);

    },

    clearLinkObjectsForQuestion: function (linkObject) {

        var length = Greenmile.Survey.Form.linkedQuestions.length;

        if (length > 0 && linkObject.linkType === Greenmile.Survey.Link.questionLinkType) {

            for (var i = length - 1; i >= 0; i--) {

                var link = Greenmile.Survey.Form.linkedQuestions[i];

                if (link.questionId === linkObject.questionId) {

                    Greenmile.Survey.Form.linkedQuestions.splice(i, 1);

                }

            }

        }

    },

    getParentElement: function (linkData) {

        var selector;

        if (linkData.linkType === Greenmile.Survey.Link.answerLinkType) {

            selector = '#' + linkData.answerId;

        } else {

            selector = 'div[question_id="' + linkData.questionId + '"] .newQuestionHeader';

        }

          return $(selector)[0];
    },

    removePreviousLinkTag: function (parentElement) {

        var linkTag = ( parentElement ) ? parentElement.querySelector('.linkTag') : undefined,
            parent;

        if (linkTag) {

            parent = linkTag.parentNode;
            parent.removeChild(linkTag);

        }

    },

    hideAnswerLinks: function (linkObject) {

        this.toggleAnswerLinks(linkObject, 'none');

    },

    showAnswerLinks: function (linkObject) {

        this.toggleAnswerLinks(linkObject, 'inline-block');

    },

    toggleAnswerLinks: function (linkObject, display) {

        var questionData = Greenmile.Survey.Data.findQuestion(linkObject.questionId),
            linkElements,
            linkTags,
            element,
            parentElement;

        if (linkObject.linkType !== Greenmile.Survey.Link.questionLinkType) {

            return;

        }

        if (questionData.surveyQuestionDomain) {

            var baseSelector = '.newQuestionContent[question_id="' + linkObject.questionId + '"] > .answerContent > .optionGroup ';
            linkElements = questionData.el.parentNode.querySelectorAll(baseSelector + '.answerLink');
            linkTags = questionData.el.querySelectorAll(baseSelector + '.linkTag');

            for (var i = 0; i < linkElements.length; i++) {

                element = linkElements[i];
                element.style.display = display;

            }

            for (var j = 0; j < linkTags.length; j++) {

                element = linkTags[j];

                parentElement = element.parentNode;
                parentElement.removeChild(element);

            }

        }

    },

    sectionHasTitle: function (section) {

        var sectionTitle;
        var isValid = false;

        if (section) {

            sectionTitle = section.querySelector('[name*="survey_section_title_"]');

            if (sectionTitle.value) {

                sectionTitle.className = '';
                isValid = true;

            } else {

                sectionTitle.className = 'surveyInvalidField';

            }

        }

        return isValid;

    },

    checkMandatoryFields: function () {

        const sections = Greenmile.Survey.Data.surveyData;
        const applyRule = Greenmile.Survey.SurveyApplyRule;
        const actionsList = document.querySelectorAll('.actionWidgetGroup');
        const applicationRulesSectionElement = document.querySelector('#SurveyApplyRulesRulesListContainer').parentNode;
        let sectionTitleErrors = 0;
        let sectionNoQuestion = 0;
        let questionOneSelectErrors = 0;
        let questionMultipleSelectErrors = 0;
        let actionErrors = 0;
        const sectionClassError = ' section-error';
        const fieldClassError = 'surveyInvalidField';
        const validate = {
            status: true
        };

        const addErrorToElement = function (element, classError) {

            if (element && element.className.indexOf(classError) === -1) {
                element.className += ' ' + classError;
            }

        };

        const removeErrorElement = function (element, classError) {

            if (element) {
                element.className = element.className.replace(classError, '').trim();
            }

        };

        for (let i = 0; i < sections.length; i++) {

            const section = sections[i];
            const sectionEl = section.el;

            if (!this.sectionHasTitle(sectionEl)) {
                sectionTitleErrors++;
            }

            if (!section.surveyQuestions.length) {

                addErrorToElement(sectionEl, sectionClassError);
                sectionNoQuestion++;

            } else {

                removeErrorElement(sectionEl, sectionClassError);

                const questions = section.surveyQuestions;

                for (let j = 0; j < questions.length; j++) {

                    const question = questions[j];
                    const questionEl = question.el;

                    const checkQuestionDomains = (questionCountErrors) => {
                        if (!question.surveyQuestionDomain.length) {

                            addErrorToElement(questionEl, fieldClassError);
                            questionCountErrors++;

                        } else {
                            removeErrorElement(questionEl, fieldClassError);
                        }
                    };

                    (question.questionType === 'PICKLIST')
                        && checkQuestionDomains(questionOneSelectErrors);

                    (question.questionType === 'PICKLIST_MULTISELECT')
                        && checkQuestionDomains(questionMultipleSelectErrors);

                }

            }

        }

        actionsList.forEach((actionEl) => {
            const taskTypeFieldEl = actionEl.querySelector('.taskTypeField .lookupInputContainer');
            const taskTypeInputEl = taskTypeFieldEl.querySelector('.lookUpField');
            const eventFieldEl = actionEl.querySelector('.eventField select');
            const conditionsEl = actionEl.querySelectorAll('.actionWidgetRow');


            if(eventFieldEl.value === "") {
                addErrorToElement(eventFieldEl, 'actionInvalidField');
                actionErrors++;

            } else {
                removeErrorElement(eventFieldEl, 'actionInvalidField');
            }
            if(taskTypeInputEl.value === "") {
                addErrorToElement(taskTypeFieldEl, 'actionInvalidField');
                actionErrors++;

            } else {
                removeErrorElement(taskTypeFieldEl, 'actionInvalidField');
            }

            conditionsEl.forEach((conditionEl) => {
                const conditionFieldEl = conditionEl.querySelector('.conditionField');
                const questionFieldEl = conditionEl.querySelector('.questionField');

                if(questionFieldEl.value === "") {
                    addErrorToElement(questionFieldEl, 'actionInvalidField');
                    actionErrors++;

                } else {
                    removeErrorElement(questionFieldEl, 'actionInvalidField');
                }

                if(conditionFieldEl.value === "") {
                    addErrorToElement(conditionFieldEl, 'actionInvalidField');
                    actionErrors++;

                } else {
                    removeErrorElement(conditionFieldEl, 'actionInvalidField');
                }
            });
        });

        if (sectionTitleErrors
            || sectionNoQuestion
            || questionOneSelectErrors
            || questionMultipleSelectErrors
            || actionErrors
            ) {
            validate.status = false;
        }

        if (!applyRule.data || !applyRule.data.length) {

            addErrorToElement(applicationRulesSectionElement, sectionClassError);
            validate.status = false;

        } else {
            removeErrorElement(applicationRulesSectionElement, sectionClassError);
        }

        if (validate.status) {
            return true;
        } else {
            return false;
        }

    },

    addSections: function (surveySections) {
        const canvas = document.querySelector('#Survey .sectionContainer');
        canvas.innerHTML = "";
        Greenmile.Survey.Data.surveyData = [];

        Greenmile.Survey.Form.linkedQuestions = [];

        if (surveySections && surveySections.length) {
            for (let i = 0; i < surveySections.length; i++) {

                const section        = surveySections[i],
                      sectionEl      = Greenmile.Survey.Widgets.getSectionToQuestions(section.id, section.title),
                      sectionData    = {};

                sectionData.id = section.id;
                sectionData.key = section.key;
                sectionData.el = sectionEl;
                sectionData.order = section.sectionOrder;
                sectionData.surveyQuestions = [];
                sectionData.title = section.title;

                canvas.appendChild(sectionEl);

                Greenmile.Survey.Data.addSurveySection(sectionData);

                if (section.surveyQuestions) {
                    this.addQuestions(sectionData, section, section.surveyQuestions, null);
                }
            }
          }

          Array.prototype.slice.call( document.querySelectorAll('.newQuestionContent') ).forEach(function(question){
            var sub = question.querySelector('.subQuestionContent');
            if(sub) {
              var button = Array.prototype.slice.call(question.children)
                                                .find(function(item) {
                                                  return item.type === 'button';
                                                });
              if (button) {
                  question.insertBefore(button, sub);
              }
            }
          });

    },

    addActions: function () {
        const actionSectionContainer = document.querySelector('#Survey .actionsSection #generateTaskSectionContainer');

        if (actionSectionContainer) {
            actionSectionContainer.innerHTML = '';
            Greenmile.Survey.Data.surveyActions = [];

            Greenmile.Survey.Data.setSurveyActions();
            const surveyActions = Greenmile.Survey.Data.getSurveyActions();
            surveyActions.forEach((surveyAction) => this.createNewAction(surveyAction));
        }
    },

    setReleasedAndClosedDates: function (releasedDate, closedDate) {
        Greenmile.Survey.Builder.releasedDate = releasedDate;
        Greenmile.Survey.Builder.closedDate = closedDate;
    },

    verifyQuestionsToEnableActionButton: function () {
      const addActionButton = document.querySelector('#addActionButton');
      const { surveyData } = Greenmile.Survey.Data;
      const hasSurveyQuestions = surveyData.some((section) => section.surveyQuestions.length);

      if (hasSurveyQuestions) {
        addActionButton?.removeAttribute('disabled');
        addActionButton?.removeAttribute('title');
      } else {
        addActionButton?.setAttribute('disabled', 'true');
        addActionButton?.setAttribute('title', Monet.I18n.getResourcesByKey('Survey.Actions.AddActionButton.title'));
        Greenmile.Survey.Widgets.removeAllActionsWidget();
      }
    }
};
